export default "__VITE_ASSET__CvcKDave__"